const toast = {
  message: {
    success: 'sucesso!',
    error: 'Algo correu mal.',
  },
};

export default toast;
